import axios from "axios";
import {v4 as uuidv4} from "uuid";
import Place from "@wikicasa/common/model/Place";

//@ts-ignore
import {appendQueryString} from "@utils/UrlBuilderUtils";
//@ts-ignore
import {GAutocompleteTypes, GooglePredictionType, GPlaceDetails} from "@customTypes/GAutocompleteTypes";
//@ts-ignore
import {Nullable} from "@customTypes/CustomUtilityTypes";
//@ts-ignore
import {handleAxiosError, baseURL} from "@services/servicesUtils";
//@ts-ignore
const baseController = `${baseURL}/rest/geography`

let sessionToken = uuidv4();

export const getPlacesAddressAutocomplete = async (query: string, radius: number, types: GAutocompleteTypes[] = []): Promise<GooglePredictionType[]> => {
    if (!sessionToken)
        sessionToken = uuidv4();

    const url = new URL(`${baseController}/placesAddressAutocomplete`);

    const length = types.length;
    const _types = types.reduce((acc, cur, currentIndex) => {
        if (length === 1)
            return cur;

        if (currentIndex === (length - 1))
            return acc;

        return acc += `${cur}|`;
    }, "")

    const urlWithQueryString = appendQueryString(url, {query, radius, sessionToken: sessionToken, types: _types})
    const res = await axios.get(urlWithQueryString.toString());
    if (res.data.status !== "OK")
        throw new Error("There was an error in the request");

    return res.data.predictions as GooglePredictionType[];
}

export const getPlacesDetails = async (placeId: string): Promise<GPlaceDetails> => {
    const url = new URL(`${baseController}/getPlacesDetails`);
    const urlWithQueryString = appendQueryString(url, {placeId, sessionToken: sessionToken});

    const res = await axios.get(urlWithQueryString.toString());
    sessionToken = "";

    if (res.data.status !== "OK")
        throw new Error("There was an error in the request")

    return res.data.result as GPlaceDetails;
}

export const guessPlace = async (latitude?: number, longitude?: number): Promise<Place> => {
    const url = new URL(`${baseController}/guessCityPlace/${latitude}/${longitude}`);
    const res = await axios.get(url.toString());
    return res.data as Place;
}

export const getPlaceFromPlaceID = async (id?: Nullable<number>): Promise<Place> => {
    if (id === null || id === undefined)
        throw new Error("The id can't be null");

    const res = await axios.get(`${baseController}/getPlaceFromPlaceID/${id}`);
    return res.data as Place;
}

export const getCountryPolygonJSON = async (id: number): Promise<any> => {
    try {
        const res = await axios.get(`${baseController}/getCountryPolygonJson/${id}`)
        return res.data
    } catch (e) {
        handleAxiosError(e)
        throw e
    }
}

export const getRegionPolygonJSON = async (id: number): Promise<any> => {
    try {
        const res = await axios.get(`${baseController}/getRegionPolygonJson/${id}`)
        return res.data
    } catch (e) {
        handleAxiosError(e)
        throw e
    }
}

export const getCityPolygonJSON = async (id: number): Promise<any> => {
    try {
        const res = await axios.get(`${baseController}/getCityPolygonJson/${id}`)
        return res.data
    } catch (e) {
        handleAxiosError(e)
        throw e
    }
}

export const getProvincePolygonJSON = async (id: number): Promise<any> => {
    try {
        const res = await axios.get(`${baseController}/getProvincePolygonJson/${id}`)
        return res.data
    } catch (e) {
        handleAxiosError(e)
        throw e
    }
}

export const guessZone = async (latitude?: number, longitude?: number): Promise<Place> => {
    try {
        const res = await axios.get(`${baseController}/guessZonePlace/` + latitude + "/" + longitude);
        return res.data
    } catch (e) {
        handleAxiosError(e)
        throw e;
    }
}

//return a string representing the polygon to draw
export const getAroundMePolygon = (latitude: number, longitude: number, radius: number = 0): Promise<string> => {
    return axios.get("/rest/geography/buildMapCircleArea?latitude=" + latitude + "&longitude=" + longitude + "&radius=" + radius);
}